import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ConfigProvider, Spin, theme } from 'antd';
import { initI18n } from '../../utils/locales';
import { CLIENT_NAME } from '../../constants';
import { initAuth, selectAuth } from '../../slices/auth-slice';

const _clientName = CLIENT_NAME;
const AuthenticatedApp = React.lazy(/* webpackPrefetch: true */ () => import('./AppAuthenticated'));
const UnauthenticatedApp = React.lazy(() => import('./AppUnauthenticated'));

function AppLoader() {
  return <Spin size="large" className="app-loader" />;
}

function App() {
  const { user, status } = useSelector(selectAuth);
  const dispatch = useDispatch();
  const { darkAlgorithm, defaultAlgorithm } = theme;

  const isDarkTheme = useSelector((state: any) => state.theme.darkMode);

  React.useEffect(() => {
    if (user && user?.role === 'RISK') {
      document.title = `Risk - ${_clientName}`;
    } else if (user && user?.role === 'SUPERVISOR') {
      document.title = `Admin - ${_clientName}`;
    } else {
      document.title = `Backoffice - ${_clientName}`;
    }
  }, [user?.role, user]);


  React.useEffect(() => {
    initI18n();
    dispatch<any>(initAuth());
  }, [dispatch]);

  React.useEffect(() => {
    const rootElement = document.getElementById('root');
    const body = document.getElementsByTagName('body');
    isDarkTheme ? body[0]?.classList.add('dark-theme') : body[0]?.classList.remove('dark-theme');

    if (rootElement) {
      rootElement.style.backgroundColor = isDarkTheme ? '#0e0e0e' : '#fff';
    }
  }, [isDarkTheme]);

  if (status === 'idle') {
    return <AppLoader />;
  }

  return (
    <ConfigProvider
      theme={{
        algorithm: isDarkTheme ? darkAlgorithm : defaultAlgorithm,
        token: {
          colorBgLayout: isDarkTheme ? '#0e0e0e' : '#f5f5f5',
        },
      }}
    >
      <React.Suspense fallback={<AppLoader />}>{user ? <AuthenticatedApp /> : <UnauthenticatedApp />}</React.Suspense>
    </ConfigProvider>
  );
}

export default App;






